import {
  PortPredictorBerthsData,
  PortPredictorCargoGroupTypes,
  PortPredictorPortsData,
  PortPredictorPortsTerminalsData,
  VesselPositionState
} from "./hooks/usePortPredictorAPI"

export enum CheckedMinMedianMax {
  Min = "min",
  Median = "median",
  Average = "average",
  Max = "max",
}

export enum MarkerType {
  Arrival = "arrival",
  Departure = "departure",
}

export enum PortType {
  Discharge = "discharge-port",
  Load = "load-port",
  Other = "other",
}

export enum VesselStateLadenOrBallast {
  Laden = "Laden",
  Ballast = "Ballast",
}

export interface PortPredictorChosenCargo {
  cargo: string | undefined
  cargoGroup: PortPredictorCargoGroupTypes | undefined
}

export interface PortPredictorMarkerBase {
  id: number
  lastNavStaDesc?: string
  cargo?: string
  cargoGroup?: PortPredictorCargoGroupTypes
}

export interface PortPredictorMarkerArrivalBase {
  lastPosTime?: string
  /**
   * prop used to know if need to update arrival marker turnAroundTime based
   * on user manually changing the departure date of next marker
   */
  nextMarkerDepartureDateManuallyUpdated?: boolean
}



export interface PortPredictorMarkerArrivalUserChangeProps {
  arrivalDate?: string
  markerType: MarkerType.Arrival
  portType: PortType
  vesselState: VesselStateLadenOrBallast
  port?: PortPredictorPortsTerminalsData,
  berth?: PortPredictorBerthsData,
  turnAroundTime?: number
  daysFromDeparture?: number
  distanceFromDeparture?: number
  laycanStart?: string
  laycanEnd?: string
  // Used to guess the portType when displaying the arrival form
  // These props are only needed if the first stop is an arrival stop
  vesselPosition?: VesselPositionState
}

export type PortPredictorMarkerArrival =
  PortPredictorMarkerBase & PortPredictorMarkerArrivalBase & PortPredictorMarkerArrivalUserChangeProps


export interface PortPredictorMarkerDepartureUserChangeProps {
  vesselSpeedSelected: number | undefined
  vesselState: VesselStateLadenOrBallast
  vesselMonthsAvgSelected?: number | undefined
  vesselSeaMargin?: string | undefined
}

// Instead of ? undefined properties, use null
export type PortPredictorMarkerDepartureBase = {
  date?: string
  markerType: MarkerType.Departure
  distanceToArrival?: number
  daysToArrival?: number
  posWkt?: string
  vesselPosition?: VesselPositionState.OpenSea
  port?: PortPredictorPortsData
  preserveFollowingPortType?: boolean
  departureDateManuallyUpdated?: boolean
} & PortPredictorMarkerDepartureUserChangeProps

export type PortPredictorMarkerDeparture =
  PortPredictorMarkerBase &
  PortPredictorMarkerDepartureBase &
  PortPredictorMarkerDepartureUserChangeProps

export type PortPredictorJourneyMarker =
  | PortPredictorMarkerDeparture
  | PortPredictorMarkerArrival

export type PortPredictorJourneyState = PortPredictorJourneyMarker[]

const ADD_JOURNEY_MARKER = "ADD_JOURNEY_MARKER"
export const EXTEND_JOURNEY_MARKERS = "EXTEND_JOURNEY_MARKERS"
export const ADD_JOURNEY_START_MARKERS = "ADD_JOURNEY_START_MARKERS"
const CLEAR_JOURNEY = "CLEAR_JOURNEY"
export const EDIT_JOURNEY = "EDIT_JOURNEY"
const INITIALIZE_JOURNEY_MARKER = "INITIALIZE_JOURNEY_MARKER"

export type PortPredictorJourneyActions =
  | {
    type: "INITIALIZE_JOURNEY_MARKER"
    payload: PortPredictorJourneyMarker[] | undefined
  }
  | {
    type: "ADD_JOURNEY_MARKER"
    payload: PortPredictorJourneyMarker
  }
  | {
    type: "ADD_JOURNEY_START_MARKERS"
    payload: PortPredictorJourneyMarker[]
  }
  | {
    type: "CLEAR_JOURNEY"
  }
  | {
    type: "EDIT_JOURNEY"
    payload: PortPredictorJourneyMarker[]
  }
  | {
    type: "EXTEND_JOURNEY_MARKERS"
    payload: PortPredictorJourneyMarker[]
  }

export function portPredictorJourneyReducer(
  state: PortPredictorJourneyState,
  action: PortPredictorJourneyActions
) {
  switch (action.type) {
    case INITIALIZE_JOURNEY_MARKER:
      return [...(action.payload || [])]
    case ADD_JOURNEY_MARKER:
      const final = [...state, action.payload]
      return final
    case ADD_JOURNEY_START_MARKERS:
      const r1 = [...action.payload]
      console.log('ADD JOURNEY START', r1)
      return r1
    case EXTEND_JOURNEY_MARKERS:
      return [...state, ...action.payload]
    case EDIT_JOURNEY:
      const sliceUpToButNotIncluding = action.payload[0].id
      const result = [...state.slice(0, sliceUpToButNotIncluding), ...action.payload]
      console.log('EDIT JOURNEY', result)
      return result
    case CLEAR_JOURNEY:
      console.log('CLEAR JOURNEY', [])
      return []
    default:
      return state
  }
}
